import { render } from "./FindMusicXml.vue?vue&type=template&id=56f20066"
import script from "./FindMusicXml.vue?vue&type=script&lang=js"
export * from "./FindMusicXml.vue?vue&type=script&lang=js"

import "./FindMusicXml.vue?vue&type=style&index=0&id=56f20066&lang=less"

import exportComponent from "F:\\TheDreamMusic\\aimusicxml\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__